'use client';

import { useState } from 'react';
import useTranslations from '@/core/hooks/use-translations';
import parseLocale from '@/core/i18n/parse-locale';
import Button from '@/ui/components/Button/Button';
import LanguageChangerModal from '@/ui/components/LanguageChanger/LanguageChangerModal';
import Typography from '@/ui/components/Typography/Typography';

import $ from './LanguageChanger.module.scss';

type LanguageChangerProps = {
  locale: string;
};

export default function LanguageChanger({ locale }: LanguageChangerProps) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);

  const handleClose = () => setIsOpen(false);

  const { language } = parseLocale(locale);
  const displayNames = new Intl.DisplayNames(locale, {
    type: 'language',
  });
  const languageLabel = displayNames.of(language) ?? language;

  return (
    <>
      <Button
        icon="icon-light-globe"
        ariaLabel={`${t('web_general_header_selectLanguage')}: ${languageLabel}`}
        variant="tertiary"
        className={$.button}
        onClick={handleOpen}
      >
        <Typography className={$.languageLabel}>{languageLabel}</Typography>
      </Button>
      {isOpen && <LanguageChangerModal onClose={handleClose} />}
    </>
  );
}
